// Legacy wedding-project sidebar config removed 2026-09-02 — navigation lives in
// components/SidebarNavigation.vue. Kept as an empty app config.
export default defineAppConfig({})
